import * as Yup from "yup";
import i18n from "../i18n";

export default Yup.object().shape({
  date: Yup.string().required(i18n.t("findings.copyFindingModal.dateRequired")),
});
